export interface IRoles {
  [x: string]: any;
  id?: number;
  uuid?: string;
  role_type_id?: number;
  project_id?: number;
  entrepreneur_id?: number;
  responsible_id?: number;
  name: string;
  regulatory_name: string
  description: string
  size?: number
  permission?:any[];
  latitude?: number
  longitude?: number
  geom_point?: string
  geom_polygon?: string
  geom_line?: string
  type_coordinates?: string
  type_geometry?: string
  field_id?: []
  fields?: [
    {
      id?: number;
    }
  ]
  activity_log?: [
    {
      properties?:{
        attributes?: {
          entrepreneur_id: number,
          responsible_id: number,
        }
      }
    }
  ]
}


export const rolesInitValues: IRoles = {
  // id: 0,
  name: '',
  regulatory_name: '',
  description: '',
  permission: [],
}

